import React from 'react';
import { Box, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import useStyles from '../styles';

export interface DashboardSummaryItem {
  label: string;
  value: string;
  color: string;
}

interface DashboardSummaryCardProps {
  title: string;
  detailText?: string;
  items: DashboardSummaryItem[];
  onNavigate?: () => void;
}

const DashboardSummaryCard: React.FC<DashboardSummaryCardProps> = ({
  title,
  detailText,
  items,
  onNavigate,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.summaryCard}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography variant="subtitle2" className={classes.totalLabel}>
        {title}
      </Typography>
        {onNavigate && (
          <ArrowForwardIosIcon
            onClick={onNavigate}
            style={{ cursor: 'pointer', fontSize: '1rem' }}
          />
        )}
      </Box>

      {detailText && (
        <Typography className={classes.detail}>
          {detailText}
        </Typography>
      )}

      <Box className={classes.cardItemsContainer}>
        {items.map((item) => (
          <Typography key={item.label} className={classes.cardItem}>
            <Box className={classes.cardItemName}>
              <Box
                className={classes.cardItemIcon}
                sx={{ backgroundColor: item.color }}
              />
              <span>{item.label}</span>
            </Box>
            <span>{item.value}</span>
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default DashboardSummaryCard;
